<template>
  <span v-if="pipeline && dots && parseInt(pipeline.exclude) != 1">
    <v-line
      @click="$emit('pipelineFocus')"
      :config="{
        points: getPipePoints(startX, startY, dots),
        stroke: focused ? inverse(color) : color,
        strokeWidth: pipeline.R * 20 * iconsScale,
        tension: pipeline.obj_type == 62 ? 0.5 : 0,
      }"
    >
    </v-line>

    <v-circle
      v-for="(dot, dot_index) in dots"
      v-if="!dot.deleted"
      :key="`d1-${dot_index}`"
      @mouseout="dot.focused = false"
      @mouseover="dot.focused = true"
      @mousedown.right="$emit('showPipelineNodeWindow', { pipeline: pipeline, dots: dots, dot_index: dot_index })"
      @dragEnd="$emit('pipelineNewPos', pipeline)"
      :config="{
        x: parseInt(dot.x),
        y: parseInt(dot.y),
        dragBoundFunc(pos) {
          $set(dots[dot_index], 'x', getScaledPointerPosition().x);
          $set(dots[dot_index], 'y', getScaledPointerPosition().y);
          return {
            x: pos.x,
            y: pos.y,
          };
        },
        radius: 10 * iconsScale,
        stroke: '#666',
        fill: color,
        strokeWidth: dot.valve ? 4 * iconsScale : 2 * iconsScale,
        draggable: true,
      }"
    >
    </v-circle>

    <v-text
      v-for="(dot, dot_index) in dots"
      v-if="dot_index == 0"
      :key="`d2-${dot_index}`"
      :config="{
        x: parseInt(dot.x),
        y: parseInt(dot.y) - 5 * iconsScale,
        text: '\uf11e',
        fontFamily: 'FontAwesome',
        fontSize: 18 * iconsScale,
        padding: -4 * iconsScale,
        fill: 'white',
      }"
    ></v-text>

    <v-text
      v-for="(dot, dot_index) in dots"
      v-if="dot.valve"
      :key="`d3-${dot_index}`"
      :config="{
        x: parseInt(dot.x),
        y: parseInt(dot.y) - 5 * iconsScale,
        text: '\uf0da',
        fontFamily: 'FontAwesome',
        fontSize: 18 * iconsScale,
        padding: -3 * iconsScale,
        fill: 'white',
      }"
    ></v-text>

    <span v-for="(dot, dot_index) in dots" v-if="!dot.deleted" :key="`d4-${dot_index}`">
      <pipeline
        v-if="dot.dots"
        @pipelineFocus="$emit('pipelineFocus')"
        @showPipelineNodeWindow="$emit('showPipelineNodeWindow', $event)"
        @pipelineNewPos="$emit('pipelineNewPos', $event)"
        :mapLayer="mapLayer"
        :pipeline="pipeline"
        :dots="dot.dots"
        :startX="dot.x"
        :startY="dot.y"
        :color="color"
        :iconsScale="iconsScale"
        :focused="dot.focused"
      >
      </pipeline>
    </span>
  </span>
</template>

<script>
import pipeline from "./pipeline";
export default {
  name: "pipeline",
  components: {
    pipeline,
  },
  props: {
    dots: Array,
    pipeline: Object,
    color: String,
    startX: Number,
    startY: Number,
    mapLayer: Object,
    focused: Boolean,
    iconsScale: Number,
  },
  created() {},
  data() {
    return {
      childFocus: false,
    };
  },
  methods: {
    getPipePoints(startX, startY, dots) {
      var arr = [startX, startY];
      for (let dot of dots) {
        arr.push(dot.x);
        arr.push(dot.y);
      }

      return arr;
    },
    getScaledPointerPosition(ev) {
      var stage = this.mapLayer.getStage();
      stage.setPointersPositions(ev);
      var pointerPosition = stage.getPointerPosition();
      var stageAttrs = stage.attrs;
      if (!stageAttrs.x) {
        stageAttrs.x = 0;
      }
      if (!stageAttrs.y) {
        stageAttrs.y = 0;
      }
      var x = (pointerPosition.x - stageAttrs.x) / stageAttrs.scaleX;
      var y = (pointerPosition.y - stageAttrs.y) / stageAttrs.scaleY;
      return { x: x, y: y };
    },
    inverse(color) {
      color = color.substring(1); // remove #
      color = parseInt(color, 16); // convert to integer
      color = 0xffffff ^ color; // invert three bytes
      color = color.toString(16); // convert to hex
      color = ("000000" + color).slice(-6); // pad with leading zeros
      color = "#" + color; // prepend #return color;
      return color;
    },
  },
};
</script>
